import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: null,
  token: null,
  error: null,
  loading: false,
  isUserLogout: false,
  errorMsg: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload?.data || action.payload || "Something went wrong";
      state.loading = false;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      const { accessToken, user, roleLevel, permissions, tempPermissions, roles } = action.payload;

      // ✅ FIXED: Build the complete user object once
      state.user = {
        ...user,
        roleLevel,
        permissions,
        tempPermissions: tempPermissions || [],
        roles: roles || [],
      };

      state.token = accessToken;
      state.loading = false;
      state.errorMsg = false;
    },
    logoutUserSuccess(state) {
      state.user = null;
      state.token = null;
      state.isUserLogout = true;
      state.loading = false;
    },
    reset_login_flag(state) {
      state.error = null;
      state.loading = false;
      state.errorMsg = false;
    },
    startLoading(state) {
      state.loading = true;
    },

    // Update user permissions dynamically (for temp permissions)
    updateUserPermissions: (state, action) => {
      if (state.user) {
        state.user.permissions = action.payload.permissions || state.user.permissions;
        state.user.tempPermissions = action.payload.tempPermissions || state.user.tempPermissions;
      }
    },
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  startLoading,
  updateUserPermissions,
} = loginSlice.actions;

export default loginSlice.reducer;
